export enum AddMembershipMemberDetailsFields {
  PrimaryMember = 'primaryMember',
}
